(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-intro"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest(
      '.brand-intro a[data-brand-intro-series]'
    );

    if (
      !link ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const targetId = link.hash.slice(1);
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    target.focus({ preventScroll: true });

    target.scrollIntoView({
      behavior: prefersReducedMotion ? 'instant' : 'smooth',
      block: 'start',
    });

    if (window.location.hash !== link.hash) {
      window.history.pushState(null, '', link.hash);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centuryshine-downloads"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    const initialize = (root) => {
      if (instances.has(root)) {
        return;
      }

      const items = Array.from(root.querySelectorAll('[data-downloads-faq-item]'));
      const controller = new AbortController();
      const options = { signal: controller.signal };

      const setItemOpen = (item, open) => {
        const button = item.querySelector('[data-downloads-faq-button]');
        const answer = item.querySelector('[data-downloads-faq-answer]');

        item.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        answer.setAttribute('aria-hidden', String(!open));
        answer.inert = !open;
        answer.style.maxHeight = open ? `${answer.scrollHeight}px` : '0px';
      };

      const syncOpenAnswers = () => {
        items.forEach((item) => {
          if (item.classList.contains('is-open')) {
            const answer = item.querySelector('[data-downloads-faq-answer]');
            answer.style.maxHeight = `${answer.scrollHeight}px`;
          }
        });
      };

      items.forEach((item) => {
        const button = item.querySelector('[data-downloads-faq-button]');
        setItemOpen(item, false);
        button.disabled = false;
        button.addEventListener('click', () => {
          const shouldOpen = !item.classList.contains('is-open');
          items.forEach((candidate) => {
            setItemOpen(candidate, candidate === item && shouldOpen);
          });
        }, options);
      });

      root.dataset.downloadsFaqReady = 'true';

      root.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-downloads-faq-item]');
        if (item && root.contains(item)) {
          items.forEach((candidate) => {
            setItemOpen(candidate, candidate === item);
          });
        }
      }, options);

      window.addEventListener('resize', syncOpenAnswers, options);
      const observer = new ResizeObserver(syncOpenAnswers);
      root.querySelectorAll('[data-downloads-faq-answer] > div').forEach((content) => {
        observer.observe(content);
      });

      instances.set(root, () => {
        controller.abort();
        observer.disconnect();
        items.forEach((item) => {
          const button = item.querySelector('[data-downloads-faq-button]');
          const answer = item.querySelector('[data-downloads-faq-answer]');
          item.classList.remove('is-open');
          button.disabled = true;
          button.setAttribute('aria-expanded', 'true');
          answer.removeAttribute('aria-hidden');
          answer.inert = false;
          answer.style.removeProperty('max-height');
        });
        delete root.dataset.downloadsFaqReady;
        instances.delete(root);
      });
    };

    const getRoots = (scope) => {
      const roots = Array.from(scope.querySelectorAll('[data-downloads-faq-root]'));
      if (scope.matches && scope.matches('[data-downloads-faq-root]')) {
        roots.unshift(scope);
      }
      return roots;
    };

    const scan = (scope) => {
      getRoots(scope).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      scan(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      getRoots(event.target).forEach((root) => {
        const cleanup = instances.get(root);
        if (cleanup) {
          cleanup();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chair-configurations"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('cs-chair-configurations-showcase')) {
    customElements.define('cs-chair-configurations-showcase', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.rail = this.querySelector('.chair-configurations__rail');
        if (!this.rail) {
          this.readyFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.querySelector('.chair-configurations__rail')) this.connectedCallback();
          });
          return;
        }
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.setAttribute('data-initializing', '');
        this.refresh();
        this.addEventListener('click', event => {
          const folded = event.target.closest('.chair-configurations__folded-control');
          if (folded && this.contains(folded)) {
            if (performance.now() < (this.suppressClickUntil || 0)) return;
            this.activate(this.cards.indexOf(folded.closest('.chair-configurations__variant')));
            return;
          }
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.contains(tab)) this.selectTab(tab.closest('.chair-configurations__variant'), tab.dataset.tab);
        }, { signal });
        this.rail.addEventListener('keydown', event => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const card = tab.closest('.chair-configurations__variant');
            const tabs = [...card.querySelectorAll('[role="tab"]')];
            const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            this.selectTab(card, tabs[index].dataset.tab);
            tabs[index].focus({ preventScroll: true });
            return;
          }
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || this.cards.length < 2) return;
          event.preventDefault();
          const direction = getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.index + (event.key === 'ArrowRight' ? direction : -direction);
          this.activate(index);
        }, { signal });
        this.rail.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse' || !event.isPrimary) return;
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
        }, { signal, passive: true });
        this.rail.addEventListener('pointerup', event => {
          const gesture = this.gesture;
          this.gesture = null;
          if (!gesture || event.pointerId !== gesture.id) return;
          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;
          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.25 || this.cards.length < 2) return;
          this.suppressClickUntil = performance.now() + 400;
          const rtl = getComputedStyle(this.rail).direction === 'rtl';
          this.activate(this.index + (dx < 0 ? 1 : -1) * (rtl ? -1 : 1));
        }, { signal, passive: true });
        this.rail.addEventListener('pointercancel', () => { this.gesture = null; }, { signal, passive: true });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.rail);
        this.cards.forEach(card => this.resizeObserver.observe(card.querySelector('.chair-configurations__body')));
        this.mutationObserver = new MutationObserver(() => {
          this.resizeObserver.disconnect();
          this.setAttribute('data-initializing', '');
          this.refresh();
          this.resizeObserver.observe(this.rail);
          this.cards.forEach(card => this.resizeObserver.observe(card.querySelector('.chair-configurations__body')));
          this.scheduleReady();
        });
        this.mutationObserver.observe(this.rail, { childList: true });
        document.fonts?.ready.then(() => { if (this.isConnected) this.measure(); });
        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:block:select', event => {
            const card = event.target.closest?.('[data-configuration-block]');
            if (card && this.contains(card)) this.activate(this.cards.indexOf(card));
          }, { signal });
        }
        this.scheduleReady();
      }
      scheduleReady() {
        cancelAnimationFrame(this.readyFrame);
        this.readyFrame = requestAnimationFrame(() => {
          this.measure();
          this.removeAttribute('data-initializing');
        });
      }
      refresh() {
        this.cards = [...this.rail.querySelectorAll(':scope > .chair-configurations__variant')];
        const selected = this.cards.findIndex(card => card.dataset.configurationBlock === this.dataset.activeBlock);
        this.index = selected < 0 ? 0 : selected;
        this.rail.hidden = !this.cards.length;
        this.cards.forEach(card => {
          const selectedTab = card.querySelector('[role="tab"][aria-selected="true"]');
          this.selectTab(card, selectedTab?.dataset.tab || 'dimensions');
        });
        this.measure();
        this.activate(this.index, true);
      }
      measure() {
        if (!this.cards?.length || !this.rail.clientWidth) return;
        const style = getComputedStyle(this);
        const main = this.cards.length === 1 ? 100 : this.cards.length === 2 ? 100 - Number(style.getPropertyValue('--configuration-fold')) : Number(style.getPropertyValue('--configuration-main'));
        const width = this.rail.clientWidth * main / 100;
        this.style.setProperty('--configuration-main-width', width + 'px');
        this.style.setProperty('--configuration-image-width', Math.max(1, width - 40) + 'px');
        const height = Math.ceil(Math.max(...this.cards.map(card => card.querySelector('.chair-configurations__body').getBoundingClientRect().height)));
        const value = height + 'px';
        if (this.style.getPropertyValue('--configuration-body-height') !== value) this.style.setProperty('--configuration-body-height', value);
        if (this.measuredWidth !== this.rail.clientWidth) {
          this.measuredWidth = this.rail.clientWidth;
          this.setAttribute('data-initializing', '');
          this.activate(this.index, true);
          this.scheduleReady();
        }
      }
      activate(index, initial = false) {
        const count = this.cards.length;
        if (!count || index < 0 && initial) return;
        index = (index % count + count) % count;
        if (!initial && index === this.index) return;
        const oldIndex = this.index;
        this.index = index;
        this.dataset.activeBlock = this.cards[index].dataset.configurationBlock;
        const style = getComputedStyle(this);
        const fold = count === 1 ? 0 : Number(style.getPropertyValue('--configuration-fold'));
        const main = count === 1 ? 100 : count === 2 ? 100 - fold : Number(style.getPropertyValue('--configuration-main'));
        const previous = count > 2 ? (index - 1 + count) % count : -1;
        const next = count > 1 ? (index + 1) % count : -1;
        const activeLeft = count > 2 ? fold : index === 0 ? 0 : fold;
        const focusedElement = document.activeElement;
        const focused = this.contains(focusedElement) && focusedElement.closest('.chair-configurations__variant');
        this.cards.forEach((card, i) => {
          const oldState = card.dataset.state;
          const oldSide = card.dataset.side;
          let state = 'hidden', position = 100, width = 0, side = 'next';
          if (i === index) { state = 'active'; position = activeLeft; width = main; side = 'active'; }
          else if (i === previous || count === 2 && index === 1 && i === next) { state = 'folded'; position = 0; width = fold; side = 'previous'; }
          else if (i === next) { state = 'folded'; position = activeLeft + main; width = fold; }
          else if (oldSide === 'previous') { position = -fold; side = 'previous'; }
          card.dataset.state = state;
          card.dataset.side = side;
          card.style.setProperty('--configuration-position', position + '%');
          card.style.setProperty('--configuration-width', width + '%');
          card.style.setProperty('--configuration-image-shift', side === 'previous' ? '12px' : side === 'next' ? '-12px' : '0px');
          card.setAttribute('aria-hidden', String(state === 'hidden'));
          card.inert = state === 'hidden';
          const body = card.querySelector('.chair-configurations__body');
          const control = card.querySelector('.chair-configurations__folded-control');
          body.inert = state !== 'active';
          body.setAttribute('aria-hidden', String(state !== 'active'));
          control.inert = state !== 'folded';
          control.tabIndex = state === 'folded' ? 0 : -1;
          control.setAttribute('aria-hidden', String(state !== 'folded'));
          card.relocation?.cancel();
          if (!initial && oldState === 'folded' && state === 'folded' && oldSide !== side && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
            card.relocation = card.animate([{ opacity: 1 }, { opacity: 0, offset: 0.12 }, { opacity: 0, offset: 0.8 }, { opacity: 1 }], { duration: 750, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
          }
        });
        if (!initial && focused && (this.cards.indexOf(focused) !== index || focusedElement.closest('.chair-configurations__folded-control'))) this.rail.focus({ preventScroll: true });
        if (!initial && oldIndex !== index) this.dispatchEvent(new CustomEvent('configuration:change', { detail: { blockId: this.dataset.activeBlock } }));
      }
      selectTab(card, selected) {
        card.querySelectorAll('[role="tab"]').forEach(tab => {
          const active = tab.dataset.tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        card.querySelectorAll('[role="tabpanel"]').forEach(panel => {
          const active = panel.dataset.panel === selected;
          panel.dataset.active = String(active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        });
      }
      cleanup() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.cards?.forEach(card => card.relocation?.cancel());
        cancelAnimationFrame(this.readyFrame);
        this.gesture = null;
      }
      disconnectedCallback() { this.cleanup(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    const initialize = (root) => {
      if (instances.has(root)) {
        return;
      }

      const items = Array.from(root.querySelectorAll('[data-faq-item]'));
      const controller = new AbortController();
      const options = { signal: controller.signal };

      const setItemOpen = (item, open) => {
        const button = item.querySelector('[data-faq-button]');
        const answer = item.querySelector('[data-faq-answer]');

        item.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        answer.setAttribute('aria-hidden', String(!open));
        answer.inert = !open;
        answer.style.maxHeight = open ? `${answer.scrollHeight}px` : '0px';
      };

      const syncOpenAnswers = () => {
        items.forEach((item) => {
          if (item.classList.contains('is-open')) {
            const answer = item.querySelector('[data-faq-answer]');
            answer.style.maxHeight = `${answer.scrollHeight}px`;
          }
        });
      };

      items.forEach((item) => {
        const button = item.querySelector('[data-faq-button]');
        setItemOpen(item, false);
        button.disabled = false;
        button.addEventListener('click', () => {
          const shouldOpen = !item.classList.contains('is-open');
          items.forEach((candidate) => {
            setItemOpen(candidate, candidate === item && shouldOpen);
          });
        }, options);
      });

      root.dataset.faqReady = 'true';

      root.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-faq-item]');
        if (item && root.contains(item)) {
          items.forEach((candidate) => {
            setItemOpen(candidate, candidate === item);
          });
        }
      }, options);

      window.addEventListener('resize', syncOpenAnswers, options);
      const observer = new ResizeObserver(syncOpenAnswers);
      root.querySelectorAll('[data-faq-answer] > div').forEach((content) => {
        observer.observe(content);
      });

      instances.set(root, () => {
        controller.abort();
        observer.disconnect();
        items.forEach((item) => {
          const button = item.querySelector('[data-faq-button]');
          const answer = item.querySelector('[data-faq-answer]');
          item.classList.remove('is-open');
          button.disabled = true;
          button.setAttribute('aria-expanded', 'true');
          answer.removeAttribute('aria-hidden');
          answer.inert = false;
          answer.style.removeProperty('max-height');
        });
        delete root.dataset.faqReady;
        instances.delete(root);
      });
    };

    const getRoots = (scope) => {
      const roots = Array.from(scope.querySelectorAll('[data-faq-root]'));
      if (scope.matches && scope.matches('[data-faq-root]')) {
        roots.unshift(scope);
      }
      return roots;
    };

    const scan = (scope) => {
      getRoots(scope).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      scan(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      getRoots(event.target).forEach((root) => {
        const cleanup = instances.get(root);
        if (cleanup) {
          cleanup();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail-navigation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registryKey = 'productDetailNavigationTabs';

    if (window[registryKey]) return;

    const activateTab = (root, selectedTab, shouldFocus = false) => {
      const tabs = Array.from(root.querySelectorAll('[data-component-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-component-panel]'));
      const selectedCategory = selectedTab.dataset.componentTab;

      tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', String(isSelected));
        tab.tabIndex = isSelected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.componentPanel !== selectedCategory;
      });

      if (shouldFocus) selectedTab.focus();
    };

    const initializeRoot = (root) => {
      if (!root || root.dataset.tabsInitialized === 'true') return;

      const tabs = Array.from(root.querySelectorAll('[data-component-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-component-panel]'));

      if (!tabs.length || !panels.length) return;

      root.dataset.tabsInitialized = 'true';

      const initialTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      activateTab(root, initialTab);

      root.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;

        const selectedTab = event.target.closest('[data-component-tab]');
        if (!selectedTab || !root.contains(selectedTab)) return;

        activateTab(root, selectedTab);
      });

      root.addEventListener('keydown', (event) => {
        if (!(event.target instanceof Element)) return;

        const currentTab = event.target.closest('[data-component-tab]');
        if (!currentTab || !root.contains(currentTab)) return;

        const currentIndex = tabs.indexOf(currentTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activateTab(root, tabs[nextIndex], true);
      });

      root.addEventListener('shopify:block:select', (event) => {
        if (!(event.target instanceof Element)) return;

        const imageBlock = event.target.closest('[data-component-image-category]');
        if (!imageBlock || !root.contains(imageBlock)) return;

        const category = imageBlock.dataset.componentImageCategory;
        const selectedTab = tabs.find((tab) => tab.dataset.componentTab === category);

        if (selectedTab) activateTab(root, selectedTab);
      });
    };

    const initializeWithin = (scope) => {
      if (!scope) return;

      if (scope instanceof Element && scope.matches('[data-product-detail-navigation]')) {
        initializeRoot(scope);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll('[data-product-detail-navigation]').forEach(initializeRoot);
      }
    };

    window[registryKey] = { initializeRoot, initializeWithin };

    document.addEventListener('shopify:section:load', (event) => {
      window[registryKey].initializeWithin(event.target);
    });

    const initializeDocument = () => {
      window[registryKey].initializeWithin(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeDocument, { once: true });
    } else {
      initializeDocument();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail-tab"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.productDetailTabLifecycleReady) return;
    window.productDetailTabLifecycleReady = true;

    const controllers = new WeakMap();

    const getSections = (target) => {
      if (!(target instanceof Element)) return [];
      if (target.matches('[data-product-detail-tab]')) return [target];
      return [...target.querySelectorAll('[data-product-detail-tab]')];
    };

    const initializeSection = (section) => {
      const previousController = controllers.get(section);
      if (previousController) previousController.abort();

      const controller = new AbortController();
      controllers.set(section, controller);

      const tabs = [...section.querySelectorAll('.product-info-tab')];
      const panels = [...section.querySelectorAll('[data-panel]')];
      const modelDimensionTriggers = [...section.querySelectorAll('.model-dimension-accordion__trigger')];
      const accessoryTriggers = [...section.querySelectorAll('.accessory-accordion__trigger')];

      if (tabs.length === 0) return;

      const activateTab = (tab) => {
        const activeKey = tab.dataset.tab;

        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== activeKey;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab), { signal: controller.signal });

        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let targetIndex = index;
          if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') targetIndex = 0;
          if (event.key === 'End') targetIndex = tabs.length - 1;

          tabs[targetIndex].focus();
          activateTab(tabs[targetIndex]);
        }, { signal: controller.signal });
      });

      [...modelDimensionTriggers, ...accessoryTriggers].forEach((trigger) => {
        const accordion = trigger.closest('details');
        if (!accordion) return;

        const syncExpandedState = () => {
          trigger.setAttribute('aria-expanded', String(accordion.open));
        };

        syncExpandedState();
        accordion.addEventListener('toggle', syncExpandedState, { signal: controller.signal });
      });

      const initialTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      activateTab(initialTab);
    };

    document.querySelectorAll('[data-product-detail-tab]').forEach(initializeSection);

    document.addEventListener('shopify:section:load', (event) => {
      getSections(event.target).forEach(initializeSection);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      getSections(event.target).forEach((section) => {
        const controller = controllers.get(section);
        if (controller) {
          controller.abort();
          controllers.delete(section);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('series-accordion')) {
    customElements.define('series-accordion', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.controller = new AbortController();

        const desktop = window.matchMedia(
          '(min-width: 990px) and (hover: hover) and (pointer: fine)'
        );
        const reduced = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );
        const options = { signal: this.controller.signal };

        const hoverDelay = 140;
        const animationDuration = 480;

        let hoveredPanel = null;
        let pendingPanel = null;
        let lockedUntil = 0;
        let lastX = null;
        let lastY = null;

        const getPanel = (target) => {
          if (!(target instanceof Element)) return null;

          const panel = target.closest(
            'details.product-explorer__panel'
          );

          if (!panel || panel.closest('series-accordion') !== this) {
            return null;
          }

          return panel;
        };

        const cancelHover = () => {
          clearTimeout(this.hoverTimer);
          this.hoverTimer = null;
          pendingPanel = null;
        };

        const activate = (panel) => {
          if (!panel || panel.closest('series-accordion') !== this) {
            return;
          }

          cancelHover();

          if (panel.open) return;

          lockedUntil = Date.now() + (
            reduced.matches ? 0 : animationDuration
          );

          this.querySelectorAll(
            'details.product-explorer__panel'
          ).forEach((item) => {
            if (item.closest('series-accordion') !== this) return;

            item.open = item === panel;
            item.querySelectorAll(
              '.product-explorer__series-link, .product-explorer__image-link'
            ).forEach((link) => {
              link.tabIndex = item.open ? 0 : -1;
            });
          });
        };

        const scheduleHover = (panel) => {
          if (!desktop.matches || !panel || panel.open) {
            cancelHover();
            return;
          }

          if (pendingPanel === panel) return;

          cancelHover();
          pendingPanel = panel;

          const remainingLock = Math.max(
            0,
            lockedUntil - Date.now()
          );
          const delay = Math.max(hoverDelay, remainingLock);

          this.hoverTimer = setTimeout(() => {
            this.hoverTimer = null;
            pendingPanel = null;

            if (
              !this.isConnected ||
              !desktop.matches ||
              hoveredPanel !== panel ||
              !panel.matches(':hover')
            ) {
              return;
            }

            activate(panel);
          }, delay);
        };

        const handleClick = (event) => {
          if (
            event.defaultPrevented ||
            !(event.target instanceof Element)
          ) {
            return;
          }

          const trigger = event.target.closest(
            'summary.product-explorer__trigger'
          );
          const panel = getPanel(trigger);

          if (!trigger || !panel) return;

          // 未展開：只展開，不前往連結。
          if (!panel.open) {
            event.preventDefault();
            activate(panel);
            return;
          }

          cancelHover();

          // 直接點到連結：保留瀏覽器原生連結行為。
          const clickedLink = event.target.closest(
            'a.product-explorer__series-link, a.product-explorer__image-link'
          );

          if (clickedLink) return;

          // 已展開但點到圖片或其他區域：使用該卡片的連結跳轉。
          event.preventDefault();

          const panelLink = panel.querySelector(
            'a.product-explorer__image-link[href], a.product-explorer__series-link[href]'
          );

          if (!panelLink) return;

          window.location.assign(panelLink.href);
        };


        const handlePointerMove = (event) => {
          if (!desktop.matches || event.pointerType !== 'mouse') {
            return;
          }

          if (
            event.clientX === lastX &&
            event.clientY === lastY
          ) {
            return;
          }

          lastX = event.clientX;
          lastY = event.clientY;
          hoveredPanel = getPanel(event.target);

          scheduleHover(hoveredPanel);
        };

        const handlePointerOut = (event) => {
          if (
            hoveredPanel &&
            event.relatedTarget instanceof Node &&
            hoveredPanel.contains(event.relatedTarget)
          ) {
            return;
          }

          hoveredPanel = null;
          cancelHover();
        };

        const handlePointerLeave = () => {
          hoveredPanel = null;
          lastX = null;
          lastY = null;
          cancelHover();
        };

        const handleDesktopChange = () => {
          handlePointerLeave();
          lockedUntil = 0;
        };

        const handleBlockSelect = (event) => {
          const panel = getPanel(event.target);
          if (!panel) return;

          activate(panel);
        };

        this.addEventListener(
          'click',
          handleClick,
          options
        );
        this.addEventListener(
          'pointermove',
          handlePointerMove,
          options
        );
        this.addEventListener(
          'pointerout',
          handlePointerOut,
          options
        );
        this.addEventListener(
          'pointerleave',
          handlePointerLeave,
          options
        );
        this.addEventListener(
          'shopify:block:select',
          handleBlockSelect,
          options
        );
        desktop.addEventListener(
          'change',
          handleDesktopChange,
          options
        );
      }

      disconnectedCallback() {
        clearTimeout(this.hoverTimer);
        this.controller?.abort();

        this.hoverTimer = null;
        this.controller = null;
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-accessories"] && !Shopify.designMode) return;
  try {
    

  (() => {
    const instances = new WeakMap();

    const initialize = (root) => {
      if (instances.has(root)) {
        return;
      }

      const items = Array.from(root.querySelectorAll('[data-accessory-accordion-item]'));
      const controller = new AbortController();
      const options = { signal: controller.signal };

      const setItemOpen = (item, open) => {
        const button = item.querySelector('[data-accessory-accordion-button]');
        const answer = item.querySelector('[data-accessory-accordion-answer]');

        item.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        answer.setAttribute('aria-hidden', String(!open));
        answer.inert = !open;
        answer.style.maxHeight = open ? `${answer.scrollHeight}px` : '0px';
      };

      const syncOpenAnswers = () => {
        items.forEach((item) => {
          if (item.classList.contains('is-open')) {
            const answer = item.querySelector('[data-accessory-accordion-answer]');
            answer.style.maxHeight = `${answer.scrollHeight}px`;
          }
        });
      };

      const defaultItem = items.find((item) => {
        const button = item.querySelector('[data-accessory-accordion-button]');
        const answer = item.querySelector('[data-accessory-accordion-answer]');
        if (!button || !answer || !button.textContent.trim()) return false;
        if (item.closest('[hidden], [aria-hidden="true"], [inert]')) return false;
        const style = window.getComputedStyle(button);
        if (!button.getClientRects().length || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
        return Array.from(answer.querySelectorAll('.series-accessories__item')).some((option) =>
          option.textContent.trim() || option.querySelector('img')
        );
      });

      items.forEach((item) => {
        const button = item.querySelector('[data-accessory-accordion-button]');
        setItemOpen(item, item === defaultItem);
        button.disabled = false;
        button.addEventListener('click', () => {
          const shouldOpen = !item.classList.contains('is-open');
          items.forEach((candidate) => {
            setItemOpen(candidate, candidate === item && shouldOpen);
          });
        }, options);
      });

      root.dataset.accessoryAccordionReady = 'true';

      root.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-accessory-accordion-item]');
        if (item && root.contains(item)) {
          items.forEach((candidate) => {
            setItemOpen(candidate, candidate === item);
          });
        }
      }, options);

      window.addEventListener('resize', syncOpenAnswers, options);
      const observer = new ResizeObserver(syncOpenAnswers);
      root.querySelectorAll('[data-accessory-accordion-answer] > div').forEach((content) => {
        observer.observe(content);
      });

      instances.set(root, () => {
        controller.abort();
        observer.disconnect();
        items.forEach((item) => {
          const button = item.querySelector('[data-accessory-accordion-button]');
          const answer = item.querySelector('[data-accessory-accordion-answer]');
          item.classList.remove('is-open');
          button.disabled = true;
          button.setAttribute('aria-expanded', 'true');
          answer.removeAttribute('aria-hidden');
          answer.inert = false;
          answer.style.removeProperty('max-height');
        });
        delete root.dataset.accessoryAccordionReady;
        instances.delete(root);
      });
    };

    const getRoots = (scope) => {
      const roots = Array.from(scope.querySelectorAll('[data-accessory-accordion-root]'));
      if (scope.matches && scope.matches('[data-accessory-accordion-root]')) {
        roots.unshift(scope);
      }
      return roots;
    };

    const scan = (scope) => {
      getRoots(scope).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      scan(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      getRoots(event.target).forEach((root) => {
        const cleanup = instances.get(root);
        if (cleanup) {
          cleanup();
        }
      });
    });
  })();

if (!customElements.get('accessory-option-strip')) {
  customElements.define('accessory-option-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const desktop = matchMedia('(min-width: 990px)');
      this.frame = 0;
      this.update = () => {
        this.frame = 0;
        const items = Array.from(this.querySelectorAll('.series-accessories__item'));
        if (!items.length) return;
        const left = this.getBoundingClientRect().left;
        const active = items.reduce((closest, item) => Math.abs(item.getBoundingClientRect().left - left) < Math.abs(closest.getBoundingClientRect().left - left) ? item : closest);
        items.forEach(item => item.dataset.active = String(item === active));
        const range = this.scrollWidth - this.clientWidth;
        const position = Math.abs(this.scrollLeft);
        const rtl = getComputedStyle(this).direction === 'rtl';
        const overflow = (desktop.matches || matchMedia('(max-width: 749px)').matches) && range > 1;
        this.dataset.overflow = String(overflow);
        this.dataset.hiddenLeft = String(overflow && (rtl ? range - position : position) > 1);
        this.dataset.hiddenRight = String(overflow && (rtl ? position : range - position) > 1);

      };
      const schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      };
      this.addEventListener('scroll', schedule, { passive: true, signal: this.controller.signal });
      desktop.addEventListener('change', schedule, options);

      let drag = null;
      this.addEventListener('pointerdown', event => {
        if (!desktop.matches || event.pointerType !== 'mouse' || event.button !== 0 || this.scrollWidth <= this.clientWidth || event.target.closest('a, button, input')) return;
        drag = { id: event.pointerId, x: event.clientX, left: this.scrollLeft };
      }, options);
      this.addEventListener('pointermove', event => {
        if (!drag || drag.id !== event.pointerId) return;
        const distance = event.clientX - drag.x;
        if (!this.classList.contains('is-dragging') && Math.abs(distance) < 5) return;
        this.setPointerCapture(event.pointerId);
        this.classList.add('is-dragging');
        event.preventDefault();
        this.scrollLeft = drag.left - distance;
      }, options);
      const stopDrag = () => {
        if (drag && this.hasPointerCapture(drag.id)) this.releasePointerCapture(drag.id);
        drag = null;
        this.classList.remove('is-dragging');
      };
      this.addEventListener('pointerup', stopDrag, options);
      this.addEventListener('pointercancel', stopDrag, options);
      this.addEventListener('lostpointercapture', stopDrag, options);
      this.addEventListener('pointerleave', () => { if (!this.classList.contains('is-dragging')) stopDrag(); }, options);
      this.addEventListener('dragstart', event => { if (desktop.matches) event.preventDefault(); }, options);
      this.stopDrag = stopDrag;
      this.resizeObserver = new ResizeObserver(schedule);
      this.resizeObserver.observe(this);
      this.querySelectorAll('.series-accessories__item').forEach(item => this.resizeObserver.observe(item));
      this.update();
    }
    disconnectedCallback() {
      this.stopDrag?.();
      this.controller.abort();
      this.controller = null;
      this.resizeObserver.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-dimensions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('series-dimensions')) {
    customElements.define('series-dimensions', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        if (document.readyState === 'loading') {
          if (this.readyListener) return;

          this.readyListener = () => {
            this.readyListener = null;
            if (this.isConnected) this.connectedCallback();
          };

          document.addEventListener(
            'DOMContentLoaded',
            this.readyListener,
            { once: true }
          );
          return;
        }

        this.controller = new AbortController();

        const options = { signal: this.controller.signal };

        this.tabs = [...this.querySelectorAll('.series-dimensions__tab')];
        this.panels = [...this.querySelectorAll('.series-dimensions__panel')];
        this.viewButtons = [...this.querySelectorAll('.series-dimensions__view-button')];

        this.showSpecifications(false);

        this.viewButtons.forEach(button => {
          button.disabled = false;
        });

        const scope = this.closest('main') || document;

        const synchronize = () => {
          const hero = scope.querySelector(
            'series-product-gallery.series-product-gallery--hero'
          );
          const key = hero?.active || hero?.querySelector(
            '[data-select][aria-pressed="true"]'
          )?.dataset.select;

          this.select(key, true);
        };

        document.addEventListener('series:variant-change', event => {
          if (
            !event.target.matches(
              'series-product-gallery.series-product-gallery--hero'
            ) ||
            !scope.contains(event.target)
          ) {
            return;
          }

          this.select(event.detail?.variantKey, true);
        }, options);

        const choose = key => {
          const hero = scope.querySelector(
            'series-product-gallery.series-product-gallery--hero'
          );

          if (
            typeof hero?.select === 'function' &&
            hero.buttons?.some(button => button.dataset.select === key)
          ) {
            hero.select(key);
            this.select(hero.active, true);
          } else if (!hero) {
            this.select(key, true);
          }
        };

        this.addEventListener('click', event => {
          const viewButton = event.target.closest(
            '.series-dimensions__view-button'
          );

          if (viewButton && this.viewButtons.includes(viewButton)) {
            this.showSpecifications(
              viewButton.dataset.tableView === 'specifications'
            );
            return;
          }

          const tab = event.target.closest('.series-dimensions__tab');

          if (tab && this.contains(tab)) {
            choose(tab.dataset.variantKey);
          }
        }, options);

        this.addEventListener('keydown', event => {
          const index = this.tabs.indexOf(
            event.target.closest('.series-dimensions__tab')
          );

          if (
            index < 0 ||
            !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)
          ) {
            return;
          }

          event.preventDefault();

          const next = event.key === 'Home'
            ? 0
            : event.key === 'End'
              ? this.tabs.length - 1
              : (
                index +
                (event.key === 'ArrowRight' ? 1 : -1) +
                this.tabs.length
              ) % this.tabs.length;

          choose(this.tabs[next].dataset.variantKey);
          this.tabs[next].focus({ preventScroll: true });
        }, options);

        this.addEventListener('shopify:block:select', event => {
          const tab = event.target.closest('.series-dimensions__tab');

          if (tab) choose(tab.dataset.variantKey);
        }, options);

        this.select(this.tabs[0]?.dataset.variantKey);
        synchronize();

        const list = this.querySelector('.series-dimensions__tabs');

        if (list) {
          const mobile = matchMedia('(max-width: 749px)');

          const updateIndicator = () => {
            const range = list.scrollWidth - list.clientWidth;
            const position = Math.min(
              range,
              Math.max(0, Math.abs(list.scrollLeft))
            );
            const rtl = getComputedStyle(list).direction === 'rtl';

            list.dataset.hiddenLeft = String(
              mobile.matches &&
              (rtl ? range - position : position) > 1
            );
            list.dataset.hiddenRight = String(
              mobile.matches &&
              (rtl ? position : range - position) > 1
            );

            return range > 1;
          };

          const onScroll = () => {
            updateIndicator();
          };

          this.stopScrollIndicator = () => {
            list.removeEventListener('scroll', onScroll);
            this.scrollObserver?.disconnect();
            list.dataset.hiddenLeft = 'false';
            list.dataset.hiddenRight = 'false';
          };

          const syncMobile = () => {
            this.stopScrollIndicator();
            if (!mobile.matches) return;

            list.addEventListener('scroll', onScroll, { passive: true });
            this.scrollObserver = new ResizeObserver(updateIndicator);
            this.scrollObserver.observe(list);

            this.tabs.forEach(tab => {
              this.scrollObserver.observe(tab);
            });

            updateIndicator();
          };

          mobile.addEventListener('change', syncMobile, options);
          syncMobile();
        }
      }

      showSpecifications(show) {
        this.viewButtons.forEach(button => {
          button.setAttribute(
            'aria-pressed',
            String(
              (button.dataset.tableView === 'specifications') === show
            )
          );
        });

        this.querySelectorAll('[data-table]').forEach(table => {
          table.hidden = (table.dataset.table === 'specifications') !== show;
        });
      }

      select(key, reveal = false) {
        const tab = this.tabs.find(item => item.dataset.variantKey === key);
        if (!tab) return;

        if (
          tab.getAttribute('aria-selected') !== 'true' ||
          this.panels.filter(panel => !panel.hidden).length !== 1
        ) {
          this.tabs.forEach(item => {
            item.setAttribute('aria-selected', String(item === tab));
            item.tabIndex = item === tab ? 0 : -1;
          });

          this.panels.forEach(panel => {
            panel.hidden = panel.dataset.variantKey !== key;
          });
        }

        if (reveal) {
          const list = tab.parentElement;

          if (tab.offsetLeft < list.scrollLeft) {
            list.scrollLeft = tab.offsetLeft;
          } else if (
            tab.offsetLeft + tab.offsetWidth >
            list.scrollLeft + list.clientWidth
          ) {
            list.scrollLeft =
              tab.offsetLeft + tab.offsetWidth - list.clientWidth;
          }
        }
      }

      disconnectedCallback() {
        if (this.readyListener) {
          document.removeEventListener(
            'DOMContentLoaded',
            this.readyListener
          );
          this.readyListener = null;
        }

        this.stopScrollIndicator?.();
        this.controller?.abort();
        this.controller = null;

        this.viewButtons?.forEach(button => {
          button.disabled = true;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-materials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fabric-selector')) {
  customElements.define('fabric-selector', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const tabs = Array.from(this.querySelectorAll('.series-materials__tab'));
      const panels = Array.from(this.querySelectorAll('.series-materials__panel'));
      if (!tabs.length) return;
      const section = this.closest('.series-materials');
      const synchronizeHeight = () => {
        const landingOffset = parseFloat(this.style.scrollMarginTop);
        if (Number.isFinite(landingOffset)) section.style.setProperty('--series-materials-viewport-height', `max(0px, calc(100dvh - ${landingOffset}px))`);
        else section.style.removeProperty('--series-materials-viewport-height');
      };
      this.landingObserver = new MutationObserver(synchronizeHeight);
      this.landingObserver.observe(this, { attributes: true, attributeFilter: ['style'] });
      synchronizeHeight();
      const select = index => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        panels.forEach(panel => {
          const active = panel.id === tabs[index].getAttribute('aria-controls');
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
          if (active) panel.setAttribute('aria-labelledby', tabs[index].id);
        });
      };
      this.querySelector('.series-materials__selector').setAttribute('role', 'tablist');
      panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', () => select(i), { signal: this.controller.signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(next);
          tabs[next].focus();
        }, { signal: this.controller.signal });
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('.series-materials__panel');
        const index = tabs.findIndex(tab => tab.dataset.group === panel?.dataset.group);
        if (index >= 0) select(index);
      }, { signal: this.controller.signal });
      select(0);
      this.dataset.ready = '';
    }
    disconnectedCallback() { this.controller?.abort(); this.landingObserver?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-product-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('series-product-gallery')) {
  customElements.define('series-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      if (document.readyState === 'loading') {
        if (this.readyListener) return;
        this.readyListener = () => { this.readyListener = null; if (this.isConnected) this.connectedCallback(); };
        document.addEventListener('DOMContentLoaded', this.readyListener, { once: true });
        return;
      }
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = [...this.querySelectorAll('[data-select]')];
      this.pillList = this.querySelector('.series-product-gallery__pills');
      this.pillList?.addEventListener('scroll', () => this.updatePillHint(), { ...options, passive: true });
      this.views = [...this.querySelectorAll('[data-view]')];
      this.galleries = [...this.querySelectorAll('[data-gallery]')];
      this.angle = '1';
      this.active = this.buttons.find(button => button.getAttribute('aria-pressed') === 'true')?.dataset.select || this.buttons[0]?.dataset.select;
      this.updateSelection();
      this.measureContent();
      this.sizeObserver = new ResizeObserver(() => this.measureContent());
      this.sizeObserver.observe(this.querySelector('.series-product-gallery__index'));
      if (this.pillList) this.sizeObserver.observe(this.pillList);
      this.updateGallery();
      this.settle();
      this.addEventListener('click', event => { const button = event.target.closest('[data-select]'); if (button && this.contains(button)) this.select(button.dataset.select);
        const gallery = event.target.closest('[data-gallery]');
        if (!gallery || gallery.dataset.gallery !== this.active || !this.contains(gallery)) return;
        const thumbnail = event.target.closest('[data-angle-select]');
        if (thumbnail) this.selectAngle(thumbnail.dataset.angleSelect);
        const arrow = event.target.closest('[data-angle-step]');
        if (arrow && !arrow.disabled) {
          this.stepAngle(Number(arrow.dataset.angleStep));
        }
      }, options);
      let swipe = null;
      const stage = this.querySelector('.series-product-gallery__main-stage');
      stage?.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' && window.innerWidth < 990) swipe = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, options);
      stage?.addEventListener('pointerup', event => {
        if (!swipe || swipe.id !== event.pointerId) return;
        const x = event.clientX - swipe.x, y = event.clientY - swipe.y;
        swipe = null;
        if (Math.abs(x) > 40 && Math.abs(x) > Math.abs(y)) this.stepAngle(x < 0 ? 1 : -1);
      }, options);
      stage?.addEventListener('pointercancel', () => { swipe = null; }, options);
      this.addEventListener('keydown', event => {
        const current = this.buttons.indexOf(event.target.closest('[data-select]'));
        if (current < 0 || !['ArrowDown','ArrowUp','ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : (current + (['ArrowDown','ArrowRight'].includes(event.key) ? 1 : -1) + this.buttons.length) % this.buttons.length;
        this.select(this.buttons[next].dataset.select);
        this.buttons[next].focus({ preventScroll: true });
      }, options);
      this.addEventListener('shopify:block:select', event => { const row = event.target.closest('[data-variant]'); if (row) { this.select(row.dataset.variant); if (row.dataset.angleSelect) this.selectAngle(row.dataset.angleSelect); } }, options);
    }
    updatePillHint() {
      if (!this.pillList) return;
      const range = Math.max(0, this.pillList.scrollWidth - this.pillList.clientWidth);
      const position = Math.min(range, Math.max(0, Math.abs(this.pillList.scrollLeft)));
      const rtl = getComputedStyle(this.pillList).direction === 'rtl';
      this.pillList.dataset.hiddenLeft = String(window.innerWidth <= 749 && (rtl ? range - position : position) > 1);
      this.pillList.dataset.hiddenRight = String(window.innerWidth <= 749 && (rtl ? position : range - position) > 1);
    }
    measureContent() {
        this.updatePillHint();
        const selected = this.querySelector('[data-gallery]:not([hidden]) [data-angle-select][aria-pressed="true"]');
        if (selected) this.revealThumbnail(selected);
        if (window.innerWidth < 990) {
          const index = this.querySelector('.series-product-gallery__index');
          const media = this.querySelector('.series-product-gallery__media-shell');
          const body = this.querySelector('.series-product-gallery__body');
          if (!index || !media || !body) return;
          const padding = getComputedStyle(index);
          const contentHeight = [...index.children].reduce((height, child) => {
            const spacing = getComputedStyle(child);
            return height + child.getBoundingClientRect().height + parseFloat(spacing.marginTop) + parseFloat(spacing.marginBottom);
          }, parseFloat(padding.paddingTop) + parseFloat(padding.paddingBottom));
          const ratio = getComputedStyle(media, '::before').aspectRatio.split('/').map(Number);
          const mediaHeight = media.getBoundingClientRect().width / (ratio[0] / (ratio[1] || 1));
          this.style.setProperty('--gallery-retained-height', (contentHeight + body.getBoundingClientRect().height + (window.innerWidth < 750 ? 12 : -2) + mediaHeight) + 'px');
        }
        if (window.innerWidth <= 749) {
          const contact = this.querySelector('.series-product-gallery__contact');
          const stage = this.querySelector('.series-product-gallery__stage');
          const thumbnails = this.querySelector('[data-gallery]:not([hidden]) .series-product-gallery__thumbnails');
          if (contact && stage && thumbnails) {
            const underline = getComputedStyle(contact, '::after');
            const contactBottom = contact.getBoundingClientRect().top + parseFloat(underline.top) + parseFloat(underline.height);
            const bottom = thumbnails.getBoundingClientRect().top;
            if (Number.isFinite(contactBottom) && bottom > contactBottom) {
              this.style.setProperty('--gallery-mobile-main-top', `${contactBottom - stage.getBoundingClientRect().top}px`);
              this.style.setProperty('--gallery-mobile-main-height', `${bottom - contactBottom}px`);
            }
          }
        } else {
          this.style.removeProperty('--gallery-mobile-main-top');
          this.style.removeProperty('--gallery-mobile-main-height');
        }
    }
    updateSelection() {
      this.querySelectorAll('[data-variant-intro]').forEach(description => { description.hidden = description.dataset.variantIntro !== this.active; });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.select === this.active)));
      this.dispatchEvent(new CustomEvent('series:variant-change', { bubbles: true, detail: { variantKey: this.active } }));
    }
    select(id) {
      if (id === this.active || !this.buttons.some(button => button.dataset.select === id)) return;
      this.active = id;
      this.updateSelection();
      this.angle = this.variantViews()[0]?.dataset.angle || '1';
      this.updateGallery();
      this.settle();
    }
    variantViews() { return this.views.filter(view => view.dataset.view === this.active); }
    incoming() { const angles = this.variantViews(); return angles.find(view => view.dataset.angle === this.angle) || angles[0]; }
    stepAngle(direction) {
      const angles = this.variantViews();
      const index = angles.findIndex(view => view.dataset.angle === this.angle);
      const next = angles[(index + direction + angles.length) % angles.length];
      if (next) this.selectAngle(next.dataset.angle);
    }
    selectAngle(angle) {
      if (!angle || angle === this.angle || !this.variantViews().some(view => view.dataset.angle === angle)) return;
      this.angle = angle;
      this.updateGallery();
      this.settle();
    }
    revealThumbnail(selected, animate = false) {
      const list = selected.parentElement;
      if (window.innerWidth >= 990) {
        const items = [...list.querySelectorAll('[data-angle-select]')];
        const first = items[Math.max(0, Math.min(items.indexOf(selected) - 1, items.length - 4))];
        const top = first.offsetTop;
        const smooth = animate && list.dataset.centered === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        list.scrollTo({ top, behavior: smooth ? 'smooth' : 'instant' });
        list.dataset.centered = 'true';
      } else {
        delete list.dataset.centered;
        if (selected.offsetLeft < list.scrollLeft) list.scrollLeft = selected.offsetLeft;
        else if (selected.offsetLeft + selected.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollLeft = selected.offsetLeft + selected.offsetWidth - list.clientWidth;
      }
    }
    updateGallery() {
      const incoming = this.incoming();
      if (incoming) this.angle = incoming.dataset.angle;
      this.galleries.forEach(gallery => {
        const active = gallery.dataset.gallery === this.active;
        const wasHidden = gallery.hidden;
        gallery.hidden = !active;
        if (!active) return;
        const angles = this.variantViews();
        const index = angles.indexOf(incoming);
        gallery.querySelectorAll('[data-angle-select]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.angleSelect === this.angle)));
        const selected = gallery.querySelector('[data-angle-select][aria-pressed="true"]');
        if (selected) {
          this.revealThumbnail(selected, !wasHidden);
        }
        gallery.querySelectorAll('[data-angle-step]').forEach(button => {
          button.disabled = index < 0 || angles.length < 2;
        });
      });
      const image = incoming?.querySelector('img');
      if (image && image.loading !== 'eager') image.loading = 'eager';
    }
    settle() {
      this.views.forEach(view => { view.hidden = view !== this.incoming(); view.removeAttribute('aria-hidden'); view.inert = false; view.style.zIndex = ''; });
    }
    disconnectedCallback() {
      if (this.readyListener) { document.removeEventListener('DOMContentLoaded', this.readyListener); this.readyListener = null; }
      this.sizeObserver?.disconnect();
      this.controller?.abort(); this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-service-navigation"] && !Shopify.designMode) return;
  try {
    
  function initializeSeriesServiceNavigation() {
    document.querySelectorAll('.series-service-navigation').forEach((navigation) => {
      if (navigation.dataset.initialized) return;

      navigation.dataset.initialized = 'true';

      const items = Array.from(navigation.querySelectorAll('a')).map((link) => ({
        link,
        target: document.getElementById(link.hash.slice(1))
      }));

      const resolveTargets = () => {
        items.forEach((item) => {
          item.target = document.getElementById(item.link.hash.slice(1));
        });
      };

      const wrapper = navigation.closest('.shopify-section');

      let header;

      const synchronizeOffsets = () => {
        resolveTargets();

        const headerHeight = header?.isConnected && header.querySelector('sticky-header')
          ? header.getBoundingClientRect().height
          : 0;

        wrapper.style.setProperty(
          '--series-service-header-height',
          `${headerHeight}px`
        );

        const anchorGap = parseFloat(
          window.getComputedStyle(navigation).getPropertyValue(
            '--series-service-anchor-gap'
          )
        );
        const anchorOffset =
          headerHeight + wrapper.getBoundingClientRect().height + anchorGap;

        items.forEach((item) => {
          if (item.target) {
            item.target.style.scrollMarginTop = `${anchorOffset}px`;
          }
        });
      };

      const resizeObserver = new ResizeObserver(synchronizeOffsets);

      const rebindHeader = (excludedHeader = null) => {
        const nextHeader = document.querySelector('.section-header');
        const currentHeader = nextHeader === excludedHeader ? null : nextHeader;

        if (currentHeader !== header) {
          resizeObserver.disconnect();
          header = currentHeader;

          if (header) resizeObserver.observe(header);

          resizeObserver.observe(wrapper);
        }

        synchronizeOffsets();
      };

      rebindHeader();

      let pending = false;
      let scrollTarget = null;
      let settleTimer;

      const setCurrent = (current) => {
        items.forEach((item) => {
          if (item === current) {
            item.link.setAttribute('aria-current', 'location');
          } else {
            item.link.removeAttribute('aria-current');
          }
        });

        if (!current) return;

        const row = current.link.parentElement;
        const rowBounds = row.getBoundingClientRect();
        const linkBounds = current.link.getBoundingClientRect();

        if (linkBounds.left < rowBounds.left) {
          row.scrollLeft += linkBounds.left - rowBounds.left;
        } else if (linkBounds.right > rowBounds.right) {
          row.scrollLeft += linkBounds.right - rowBounds.right;
        }
      };

      const update = () => {
        resolveTargets();

        let current = scrollTarget?.target
          ? scrollTarget
          : items.find((item) => item.target);

        items.forEach((item) => {
          if (
            !scrollTarget &&
            item.target &&
            item.target.getBoundingClientRect().top <= window.innerHeight * 0.35
          ) {
            current = item;
          }
        });

        setCurrent(current);
        pending = false;
      };

      const schedule = () => {
        if (!pending) {
          pending = true;
          requestAnimationFrame(update);
        }
      };

      const settle = () => {
        clearTimeout(settleTimer);
        scrollTarget = null;
        schedule();
      };

      const onScroll = () => {
        schedule();

        if (scrollTarget) {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(settle, 140);
        }
      };

      const controller = new AbortController();

      document.addEventListener(
        'shopify:section:load',
        () => rebindHeader(),
        { signal: controller.signal }
      );

      items.forEach((item) => {
        const { link } = item;

        link.addEventListener('click', (event) => {
          if (
            event.defaultPrevented ||
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey
          ) {
            return;
          }

          if (
            !link.getAttribute('href')?.startsWith('#') ||
            (link.target && link.target !== '_self')
          ) {
            return;
          }

          synchronizeOffsets();

          const target = item.target;

          if (!target) return;

          event.preventDefault();
          scrollTarget = item;
          setCurrent(item);

          clearTimeout(settleTimer);
          settleTimer = setTimeout(settle, 140);

          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'instant'
              : 'smooth',
            block: 'start'
          });

          if (window.location.hash !== link.hash) {
            window.history.pushState(window.history.state, '', link.hash);
          }
        }, { signal: controller.signal });
      });

      window.addEventListener('scroll', onScroll, {
        passive: true,
        signal: controller.signal
      });

      window.addEventListener('scrollend', () => {
        if (scrollTarget?.target) {
          const targetTop =
            scrollTarget.target.getBoundingClientRect().top + window.scrollY;
          const offset = parseFloat(
            getComputedStyle(scrollTarget.target).scrollMarginTop
          );
          const maxScroll =
            document.documentElement.scrollHeight - window.innerHeight;
          const destination = Math.max(
            0,
            Math.min(targetTop - offset, maxScroll)
          );

          if (Math.abs(window.scrollY - destination) > 2) return;
        }

        settle();
      }, { signal: controller.signal });

      window.addEventListener('wheel', settle, {
        passive: true,
        signal: controller.signal
      });

      window.addEventListener('touchstart', settle, {
        passive: true,
        signal: controller.signal
      });

      window.addEventListener('resize', schedule, {
        signal: controller.signal
      });

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(navigation)) {
          controller.abort();
          clearTimeout(settleTimer);
          resizeObserver.disconnect();

          items.forEach((item) => {
            item.target?.style.removeProperty('scroll-margin-top');
          });
        } else if (header && event.target.contains(header)) {
          rebindHeader(header);
        }
      }, { signal: controller.signal });

      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeSeriesServiceNavigation,
      { once: true }
    );
  } else {
    initializeSeriesServiceNavigation();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeSeriesServiceNavigation
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-variants"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('series-variants')) {
  customElements.define('series-variants', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.buttons = [...this.querySelectorAll('[data-expand]')];
      this.addEventListener('click', e => {
        const button = e.target.closest('[data-expand]');
        if (button) this.activate(this.active === button.dataset.expand ? null : button.dataset.expand);
        if (e.target.closest('[data-close]')) this.close();
      });
      this.addEventListener('keydown', e => { if (e.key === 'Escape' && this.active) this.close(); });
      this.addEventListener('shopify:block:select', e => { const item = e.target.closest('[data-variant]'); if (item) this.activate(item.dataset.variant); });
    }
    activate(id) {
      this.active = id;
      this.buttons.forEach(button => {
        const selected = button.dataset.expand === id;
        button.setAttribute('aria-expanded', String(selected));
        button.querySelector('[data-action-label]').textContent = selected ? this.dataset.closeLabel : this.dataset.openLabel;
        button.querySelector('[data-action-icon]').textContent = selected ? '−' : '+';
      });
      this.querySelectorAll('[data-detail]').forEach(panel => { panel.hidden = panel.dataset.detail !== id; });
    }
    close() {
      const button = this.buttons.find(b => b.dataset.expand === this.active);
      this.activate(null);
      if (button) button.focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
